import {useState} from 'react';
import './Stereo.css';

const Stereo = ({reel}) => {
    const [index, setIndex] = useState(1);
    return (
      <div className="Stereo">
        <div className='image-holder'
        style={{backgroundImage: `url(${process.env.PUBLIC_URL }/images/${reel}/${index}.png)`}}
        onClick={() => {
          if (index < 7) setIndex(index + 1);
          else setIndex(1);
        }}
        ></div>
      </div>
    );
}

export default Stereo;
